import {useMutation} from "react-query";
import {useFormik} from "formik";
import {useEffect} from "react";
import {useParams} from "react-router-dom";
import api from "../../services/api";
import useFetchUser from "../../hooks/useFetchUser";
import useUser from "../useUser";

const donationMutation = ({timing, ...data}) => {
    return api.post(`/timings/${timing}/donation`, data).then(response => {
        return response.data && response.data.data;
    });
};

const useDonate = (config = {}) => {
    const { timing } = useParams();

    const user = useUser();

    const mutation = useMutation(donationMutation,  {
        ...config,
        onSuccess: (data) => {
            formik.resetForm();

            if(config?.onSuccess) {
                config?.onSuccess(data);
            }

            return true;
        }
    });

    const formik = useFormik({
        initialValues: {
            name: user?.name || '',
            email: user?.email || '',
            phone: user?.phone || '',
            phone_country: user?.phone_country || 'MY',
            remark: '',

            custom_amount: false,
            amount: 10,
            payment_gateway: '',
            timing,
        },
        validate: (values) => {
            mutation.reset();

            const errors = {};

            if(!values.name) {
                errors.name = "The name field is required.";
            }
            if(values.email.length <= 3) {
                errors.email = "Your email needs to be longer than 3 characters!"
            }
            if(!values.phone) {
                errors.phone = "The phone field is required.";
            }
            if(!values.payment_gateway) {
                errors.payment_gateway = "The payment gateway field is required.";
            }

            if(parseInt(values.amount) < 10) {
                errors.amount = "Minimum donation is 10."
            }

            return errors;
        },
        onSubmit: mutation.mutateAsync,
    });

    useEffect(() => {
        if(user) {
            !formik.touched.name && formik.setFieldValue('name', user.name);
            !formik.touched.email && formik.setFieldValue('email', user.email);
            !formik.touched.phone && formik.setFieldValue('phone', user.phone);
            !formik.touched.phone_country && formik.setFieldValue('phone_country', user.phone_country || 'MY');
        }
    }, [user]);

    return {
        formik,
        mutation,
    };
};

export default useDonate;
